import { render, staticRenderFns } from "./CustomerLevelsForm.vue?vue&type=template&id=007cdcd6&scoped=true&"
import script from "./CustomerLevelsForm.vue?vue&type=script&lang=js&"
export * from "./CustomerLevelsForm.vue?vue&type=script&lang=js&"
import style0 from "./CustomerLevelsForm.vue?vue&type=style&index=0&id=007cdcd6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "007cdcd6",
  null
  
)

export default component.exports